/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import './additional_card';
import '../ui_elements/common';
import '../ui_elements/ui_element';
import '../../component/card_customization';
import './digital_wallet_configuration';
import '../../../../bbqualifier/verification_data_service';
import '../../checking_idv/checking_idv';
import '../../component/rich_text';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "OnboardingScreen": {
                    "fields": {
                      "twoFactorAuth": {
                        "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth",
                        "id": 1
                      },
                      "customization": {
                        "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization",
                        "id": 2
                      },
                      "identityVerification": {
                        "type": ".squareup.bbfrontend.service.v1.IdentityVerification",
                        "id": 3
                      },
                      "completion": {
                        "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Completion",
                        "id": 4
                      },
                      "additionalCardConfigs": {
                        "type": ".squareup.bbfrontend.service.v1.AdditionalCardScreenConfigs",
                        "id": 5
                      },
                      "confirmTosConfigs": {
                        "type": ".squareup.bbfrontend.service.v1.ConfirmTosConfigs",
                        "id": 6
                      },
                      "checkingAsDefaultIdentityVerification": {
                        "type": ".squareup.bbfrontend.service.v1.CheckingAsDefaultIdentityVerification",
                        "id": 7
                      }
                    },
                    "nested": {
                      "TwoFactorAuth": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "enterPhoneNumberConfigs": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs",
                            "id": 2,
                            "rule": "optional"
                          },
                          "enterCodeConfig": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterCodeConfigs",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "EnterPhoneNumberConfigs": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "header": {
                                "type": ".squareup.bbfrontend.service.v1.ScreenHeader",
                                "id": 2,
                                "rule": "optional"
                              },
                              "phoneNumberInput": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs.PhoneNumberInput",
                                "id": 3,
                                "rule": "optional"
                              },
                              "continueButton": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton",
                                "id": 4,
                                "rule": "optional"
                              },
                              "loadingMessage": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PhoneNumberInput": {
                                "fields": {
                                  "label": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "placeholder": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "hint": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "EnterCodeConfigs": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "header": {
                                "type": ".squareup.bbfrontend.service.v1.ScreenHeader",
                                "id": 2,
                                "rule": "optional"
                              },
                              "codeInput": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterCodeConfigs.CodeInput",
                                "id": 3,
                                "rule": "optional"
                              },
                              "submitButton": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton",
                                "id": 4,
                                "rule": "optional"
                              },
                              "resendCodeButton": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton",
                                "id": 5,
                                "rule": "optional"
                              },
                              "loadingMessage": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "CodeInput": {
                                "fields": {
                                  "label": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "placeholder": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "expectedLength": {
                                    "type": "int32",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "TwoFactorAuthButton": {
                            "fields": {
                              "text": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "isSelected": {
                                "type": "bool",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "Customization": {
                        "fields": {
                          "ownerName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "screenConfigs": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs",
                            "id": 3,
                            "rule": "optional"
                          },
                          "loadingElement": {
                            "type": ".squareup.bbfrontend.service.v1.UiElement.LoadingElement",
                            "id": 4,
                            "rule": "optional"
                          },
                          "submission": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Submission",
                            "id": 5,
                            "rule": "optional"
                          },
                          "cardBackgroundImage": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.CustomizationBackgroundImage",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ScreenConfigs": {
                            "fields": {
                              "previewScreen": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.PreviewScreen",
                                "id": 1,
                                "rule": "optional"
                              },
                              "editScreen": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen",
                                "id": 2,
                                "rule": "optional"
                              },
                              "confirmScreen": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.ConfirmScreen",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PreviewScreen": {
                                "fields": {
                                  "title": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "backButtonText": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "nextButtonText": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "blankCustomizationPlaceholderText": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "existingCustomization": {
                                    "type": ".squareup.bbfrontend.common.component.CardCustomization",
                                    "id": 5,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "EditScreen": {
                                "fields": {
                                  "options": {
                                    "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option",
                                    "id": 1,
                                    "rule": "repeated"
                                  },
                                  "backButtonText": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "nextButtonText": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "inkCoverage": {
                                    "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.InkCoverage",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "stamps": {
                                    "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Stamp",
                                    "id": 5,
                                    "rule": "repeated"
                                  },
                                  "fonts": {
                                    "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Font",
                                    "id": 6,
                                    "rule": "repeated"
                                  },
                                  "title": {
                                    "type": "string",
                                    "id": 7,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "Option": {
                                    "fields": {
                                      "type": {
                                        "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option.OptionType",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "title": {
                                        "type": "string",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "helperText": {
                                        "type": "string",
                                        "id": 3,
                                        "rule": "optional"
                                      }
                                    },
                                    "nested": {
                                      "OptionType": {
                                        "values": {
                                          "EDIT_SCREEN_OPTION_FONT": 0,
                                          "EDIT_SCREEN_OPTION_DRAWING": 1
                                        }
                                      }
                                    }
                                  }
                                }
                              },
                              "ConfirmScreen": {
                                "fields": {
                                  "title": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "backButtonText": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "nextButtonText": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "InkCoverage": {
                            "fields": {
                              "min": {
                                "type": "float",
                                "id": 1,
                                "rule": "optional",
                                "options": {
                                  "default": 0.0
                                }
                              },
                              "max": {
                                "type": "float",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": 1.0
                                }
                              }
                            }
                          },
                          "Stamp": {
                            "fields": {
                              "id": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "accessibilityLabel": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "svg": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "minScale": {
                                "type": "int32",
                                "id": 4,
                                "rule": "optional"
                              }
                            }
                          },
                          "Font": {
                            "fields": {
                              "fontFamily": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "fontUrl": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "Submission": {
                            "fields": {
                              "idempotenceKey": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "cardCustomization": {
                                "type": ".squareup.bbfrontend.common.component.CardCustomization",
                                "id": 2,
                                "rule": "optional"
                              },
                              "fontSignature": {
                                "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Submission.FontSignature",
                                "id": 3,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "FontSignature": {
                                "fields": {
                                  "font": {
                                    "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Font",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "text": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      },
                      "Completion": {
                        "fields": {
                          "customizationBackgroundImage": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.CustomizationBackgroundImage",
                            "id": 1,
                            "rule": "optional"
                          },
                          "customization": {
                            "type": ".squareup.bbfrontend.common.component.CardCustomization",
                            "id": 2,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ownerName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "title": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "message": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "digitalWalletConfiguration": {
                            "type": ".squareup.bbfrontend.service.v1.DigitalWalletConfiguration",
                            "id": 7,
                            "rule": "optional"
                          },
                          "goToBillPayButton": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "completeButton": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "cardToken": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "actionLogEvents": {
                            "type": ".squareup.bbfrontend.service.v1.OnboardingScreen.Completion.ActionLogEvents",
                            "id": 11,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ActionLogEvents": {
                            "fields": {
                              "completeButtonLogEvent": {
                                "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                "id": 1,
                                "rule": "optional"
                              },
                              "addToDigitalWalletButtonLogEvent": {
                                "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "CustomizationBackgroundImage": {
                        "values": {
                          "CUSTOMIZATION_BACKGROUND_US_CHECKING": 0,
                          "CUSTOMIZATION_BACKGROUND_CA_SQUARE_CARD": 1,
                          "CUSTOMIZATION_BACKGROUND_UK_SQUARE_CARD": 2
                        }
                      },
                      "screen": {
                        "oneof": ["twoFactorAuth", "customization", "identityVerification", "completion", "additionalCardConfigs", "confirmTosConfigs", "checkingAsDefaultIdentityVerification"]
                      }
                    }
                  },
                  "IdentityVerification": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "kybVerificationDataResponse": {
                        "type": ".squareup.bbqualifier.service.GetKybVerificationDataResponse",
                        "id": 2,
                        "rule": "optional"
                      },
                      "kybDataResponse": {
                        "type": ".squareup.bbqualifier.service.GetKybDataResponse",
                        "id": 3,
                        "rule": "optional"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.service.v1.IdentityVerification.Submission",
                        "id": 4,
                        "rule": "optional"
                      },
                      "toolbarTitle": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Submission": {
                        "fields": {
                          "hasCompleted": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      }
                    }
                  },
                  "CheckingAsDefaultIdentityVerification": {
                    "fields": {
                      "idvResult": {
                        "type": ".squareup.bbfrontend.common.checking_idv.IdvResult",
                        "id": 1,
                        "rule": "optional"
                      },
                      "submission": {
                        "type": ".squareup.bbfrontend.service.v1.CheckingAsDefaultIdentityVerification.Submission",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Submission": {
                        "fields": {
                          "hasCompleted": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      }
                    }
                  },
                  "ConfirmTosConfigs": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "descriptionText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "disclaimerText": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "agreeButtonLabel": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "confirmDisclosureLabel": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "termsLink": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "agreeButton": {
                        "type": ".squareup.bbfrontend.service.v1.ConfirmTosConfigs.AgreeButton",
                        "id": 10,
                        "rule": "optional"
                      },
                      "generalTerms": {
                        "type": ".squareup.bbfrontend.service.v1.ConfirmTosConfigs.GeneralTerms",
                        "id": 8
                      },
                      "checkableTerms": {
                        "type": ".squareup.bbfrontend.service.v1.ConfirmTosConfigs.CheckableTerms",
                        "id": 9
                      }
                    },
                    "nested": {
                      "GeneralTerms": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CheckableTerms": {
                        "fields": {
                          "textTemplate": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickableSpan": {
                            "type": ".squareup.bbfrontend.service.v1.ConfirmTosConfigs.CheckableTerms.ClickableSpan",
                            "id": 2,
                            "rule": "optional"
                          },
                          "termsRichText": {
                            "type": ".squareup.bbfrontend.common.component.RichText",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "ClickableSpan": {
                            "fields": {
                              "argument": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "text": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "AgreeButton": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "actionLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "terms_disclosure": {
                        "oneof": ["generalTerms", "checkableTerms"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth?.nested?.EnterPhoneNumberConfigs && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth?.nested?.EnterPhoneNumberConfigs?.nested?.PhoneNumberInput && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth?.nested?.EnterCodeConfigs && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth?.nested?.EnterCodeConfigs?.nested?.CodeInput && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.TwoFactorAuth?.nested?.TwoFactorAuthButton && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs?.nested?.PreviewScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs?.nested?.EditScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs?.nested?.EditScreen?.nested?.Option && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs?.nested?.EditScreen?.nested?.Option?.nested?.OptionType && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.ScreenConfigs?.nested?.ConfirmScreen && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.InkCoverage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.Stamp && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.Font && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.Submission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Customization?.nested?.Submission?.nested?.FontSignature && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Completion && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.Completion?.nested?.ActionLogEvents && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.OnboardingScreen?.nested?.CustomizationBackgroundImage && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.IdentityVerification && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.IdentityVerification?.nested?.Submission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CheckingAsDefaultIdentityVerification && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.CheckingAsDefaultIdentityVerification?.nested?.Submission && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ConfirmTosConfigs && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ConfirmTosConfigs?.nested?.GeneralTerms && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ConfirmTosConfigs?.nested?.CheckableTerms && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ConfirmTosConfigs?.nested?.CheckableTerms?.nested?.ClickableSpan && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.ConfirmTosConfigs?.nested?.AgreeButton) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE OnboardingScreen @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 20:1
 */
export const OnboardingScreen = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen');
fixType(OnboardingScreen);
Builder.createAndAttachToType(OnboardingScreen);
/**
 * Onboarding flow for the 2-FA enrollment for the Square merchants.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=1136%3A48271
 *
 * SOURCE TwoFactorAuth @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 35:3
 */
OnboardingScreen.TwoFactorAuth = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth');
fixType(OnboardingScreen.TwoFactorAuth);
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth);
/**
 * Configurations for entering your phone number.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=1136%3A47689
 *
 * SOURCE EnterPhoneNumberConfigs @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 44:5
 */
OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs');
fixType(OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs, {
  id: {
    notEmpty: true
  },
  header: {
    required: true
  },
  phoneNumberInput: {
    required: true
  },
  continueButton: {
    required: true
  },
  loadingMessage: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs);
/**
 * SOURCE PhoneNumberInput @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 51:7
 */
OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs.PhoneNumberInput = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs.PhoneNumberInput');
fixType(OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs.PhoneNumberInput, {
  label: {
    notEmpty: true
  },
  placeholder: {
    notEmpty: true
  },
  hint: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth.EnterPhoneNumberConfigs.PhoneNumberInput);
/**
 * Configurations for entering the 2-fa code.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=1138%3A50065
 *
 * SOURCE EnterCodeConfigs @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 62:5
 */
OnboardingScreen.TwoFactorAuth.EnterCodeConfigs = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterCodeConfigs');
fixType(OnboardingScreen.TwoFactorAuth.EnterCodeConfigs, {
  id: {
    notEmpty: true
  },
  header: {
    required: true
  },
  codeInput: {
    required: true
  },
  submitButton: {
    required: true
  },
  resendCodeButton: {
    required: true
  },
  loadingMessage: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth.EnterCodeConfigs);
/**
 * SOURCE CodeInput @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 70:7
 */
OnboardingScreen.TwoFactorAuth.EnterCodeConfigs.CodeInput = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.EnterCodeConfigs.CodeInput');
fixType(OnboardingScreen.TwoFactorAuth.EnterCodeConfigs.CodeInput, {
  label: {
    notEmpty: true
  },
  placeholder: {
    notEmpty: true
  },
  expectedLength: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth.EnterCodeConfigs.CodeInput);
/**
 * SOURCE TwoFactorAuthButton @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 77:5
 */
OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton');
fixType(OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.TwoFactorAuth.TwoFactorAuthButton);
/**
 * SOURCE Customization @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 83:3
 */
OnboardingScreen.Customization = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization');
fixType(OnboardingScreen.Customization, {
  ownerName: {
    notEmpty: true
  },
  businessName: {
    notEmpty: true
  },
  loadingElement: {
    required: true
  },
  cardBackgroundImage: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization);
/**
 * Configuration for each screen of the customization flow.
 *
 * SOURCE ScreenConfigs @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 103:5
 */
OnboardingScreen.Customization.ScreenConfigs = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs');
fixType(OnboardingScreen.Customization.ScreenConfigs, {
  previewScreen: {
    required: true
  },
  editScreen: {
    required: true
  },
  confirmScreen: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.ScreenConfigs);
/**
 * The initial screen that shows an existing or blank card to either accept or customize.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=202%3A101039
 *
 * SOURCE PreviewScreen @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 112:7
 */
OnboardingScreen.Customization.ScreenConfigs.PreviewScreen = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.PreviewScreen');
fixType(OnboardingScreen.Customization.ScreenConfigs.PreviewScreen, {
  title: {
    notEmpty: true
  },
  backButtonText: {
    notEmpty: true
  },
  nextButtonText: {
    notEmpty: true
  },
  blankCustomizationPlaceholderText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.ScreenConfigs.PreviewScreen);
/**
 * The screen for customizing card.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=202%3A101045
 *
 * SOURCE EditScreen @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 129:7
 */
OnboardingScreen.Customization.ScreenConfigs.EditScreen = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen');
fixType(OnboardingScreen.Customization.ScreenConfigs.EditScreen, {
  options: {
    required: true
  },
  backButtonText: {
    notEmpty: true
  },
  nextButtonText: {
    notEmpty: true
  },
  inkCoverage: {
    required: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.ScreenConfigs.EditScreen);
/**
 * Description for each type of editing option.
 *
 * SOURCE Option @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 154:9
 */
OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option');
fixType(OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option, {
  type: {
    required: true
  },
  title: {
    notEmpty: true
  },
  helperText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option);
/**
 * SOURCE OptionType @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 159:11
 */
OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option.OptionType = $root.lookupEnum('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.EditScreen.Option.OptionType').values;
/**
 * The confirmation screen to accept customization for fulfillment.
 * https://www.figma.com/file/VLhOo9Qxoxxzg8PIFJ8iyh/Onboarding?node-id=202%3A101066
 *
 * SOURCE ConfirmScreen @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 170:7
 */
OnboardingScreen.Customization.ScreenConfigs.ConfirmScreen = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.ScreenConfigs.ConfirmScreen');
fixType(OnboardingScreen.Customization.ScreenConfigs.ConfirmScreen, {
  title: {
    notEmpty: true
  },
  backButtonText: {
    notEmpty: true
  },
  nextButtonText: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.ScreenConfigs.ConfirmScreen);
/**
 * Ink coverage bounds for rendering a card customization. Values should be between 0 and 1
 * representing a percentage of ink in the canvas.
 *
 * SOURCE InkCoverage @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 181:5
 */
OnboardingScreen.Customization.InkCoverage = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.InkCoverage');
fixType(OnboardingScreen.Customization.InkCoverage);
Builder.createAndAttachToType(OnboardingScreen.Customization.InkCoverage);
/**
 * Stamp metadata to be converted to a Stamp vector on clients.
 *
 * SOURCE Stamp @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 187:5
 */
OnboardingScreen.Customization.Stamp = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Stamp');
fixType(OnboardingScreen.Customization.Stamp, {
  id: {
    notEmpty: true
  },
  accessibilityLabel: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.Stamp);
/**
 * Font metadata to be used for signature rendering on clients.
 *
 * SOURCE Font @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 199:5
 */
OnboardingScreen.Customization.Font = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Font');
fixType(OnboardingScreen.Customization.Font, {
  fontFamily: {
    notEmpty: true
  },
  fontUrl: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.Font);
/**
 * Submission to validate and save customization for manufacturing.
 *
 * SOURCE Submission @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 207:5
 */
OnboardingScreen.Customization.Submission = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Submission');
fixType(OnboardingScreen.Customization.Submission, {
  idempotenceKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.Submission);
/**
 * SOURCE FontSignature @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 214:7
 */
OnboardingScreen.Customization.Submission.FontSignature = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Customization.Submission.FontSignature');
fixType(OnboardingScreen.Customization.Submission.FontSignature, {
  font: {
    required: true
  },
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Customization.Submission.FontSignature);
/**
 * SOURCE Completion @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 221:3
 */
OnboardingScreen.Completion = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Completion');
fixType(OnboardingScreen.Completion, {
  title: {
    notEmpty: true
  },
  message: {
    notEmpty: true
  },
  completeButton: {
    notEmpty: true
  },
  cardToken: {
    notEmpty: true
  },
  actionLogEvents: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Completion);
/**
 * SOURCE ActionLogEvents @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 234:5
 */
OnboardingScreen.Completion.ActionLogEvents = $root.lookupType('squareup.bbfrontend.service.v1.OnboardingScreen.Completion.ActionLogEvents');
fixType(OnboardingScreen.Completion.ActionLogEvents, {
  completeButtonLogEvent: {
    required: true
  },
  addToDigitalWalletButtonLogEvent: {
    required: true
  }
});
Builder.createAndAttachToType(OnboardingScreen.Completion.ActionLogEvents);
/**
 * SOURCE CustomizationBackgroundImage @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 240:3
 */
OnboardingScreen.CustomizationBackgroundImage = $root.lookupEnum('squareup.bbfrontend.service.v1.OnboardingScreen.CustomizationBackgroundImage').values;
/**
 * KYB is a client only flow that expects the raw data, when KYB is server driven,
 * we will decompose and transform this models in the future, but for now we just want to
 * pipe through the data that the clients can use.
 *
 * SOURCE IdentityVerification @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 252:1
 */
export const IdentityVerification = $root.lookupType('squareup.bbfrontend.service.v1.IdentityVerification');
fixType(IdentityVerification, {
  id: {
    notEmpty: true
  },
  kybVerificationDataResponse: {
    required: true
  },
  kybDataResponse: {
    required: true
  },
  submission: {
    required: true
  },
  toolbarTitle: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IdentityVerification);
/**
 * SOURCE Submission @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 263:3
 */
IdentityVerification.Submission = $root.lookupType('squareup.bbfrontend.service.v1.IdentityVerification.Submission');
fixType(IdentityVerification.Submission);
Builder.createAndAttachToType(IdentityVerification.Submission);
/**
 * "Checking as Default" IDV client flow (for SOLE_PROPRIETORSHIP only) initiated from Square
 * Onboarding flow (aka Payments Onboarding).
 *
 * This flow handles:
 * - rendering IDV errors
 * - editing and resubmitting account holder's personal info
 *
 * SOURCE CheckingAsDefaultIdentityVerification @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 277:1
 */
export const CheckingAsDefaultIdentityVerification = $root.lookupType('squareup.bbfrontend.service.v1.CheckingAsDefaultIdentityVerification');
fixType(CheckingAsDefaultIdentityVerification, {
  idvResult: {
    required: true
  },
  submission: {
    required: true
  }
});
Builder.createAndAttachToType(CheckingAsDefaultIdentityVerification);
/**
 * SOURCE Submission @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 281:3
 */
CheckingAsDefaultIdentityVerification.Submission = $root.lookupType('squareup.bbfrontend.service.v1.CheckingAsDefaultIdentityVerification.Submission');
fixType(CheckingAsDefaultIdentityVerification.Submission);
Builder.createAndAttachToType(CheckingAsDefaultIdentityVerification.Submission);
/**
 * Confirm TOS screen for the Square Debit Card onboarding flow. This screen was first required
 * for UK onboarding implementation.
 *
 * SOURCE ConfirmTosConfigs @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 291:1
 */
export const ConfirmTosConfigs = $root.lookupType('squareup.bbfrontend.service.v1.ConfirmTosConfigs');
fixType(ConfirmTosConfigs, {
  title: {
    notEmpty: true
  },
  agreeButtonLabel: {
    notEmpty: true
  },
  termsLink: {
    notEmpty: true
  },
  agreeButton: {
    required: true
  }
});
Builder.createAndAttachToType(ConfirmTosConfigs);
/**
 * SOURCE GeneralTerms @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 308:3
 */
ConfirmTosConfigs.GeneralTerms = $root.lookupType('squareup.bbfrontend.service.v1.ConfirmTosConfigs.GeneralTerms');
fixType(ConfirmTosConfigs.GeneralTerms, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ConfirmTosConfigs.GeneralTerms);
/**
 * SOURCE CheckableTerms @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 312:3
 */
ConfirmTosConfigs.CheckableTerms = $root.lookupType('squareup.bbfrontend.service.v1.ConfirmTosConfigs.CheckableTerms');
fixType(ConfirmTosConfigs.CheckableTerms, {
  termsRichText: {
    required: true
  }
});
Builder.createAndAttachToType(ConfirmTosConfigs.CheckableTerms);
/**
 * SOURCE ClickableSpan @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 316:5
 */
ConfirmTosConfigs.CheckableTerms.ClickableSpan = $root.lookupType('squareup.bbfrontend.service.v1.ConfirmTosConfigs.CheckableTerms.ClickableSpan');
fixType(ConfirmTosConfigs.CheckableTerms.ClickableSpan);
Builder.createAndAttachToType(ConfirmTosConfigs.CheckableTerms.ClickableSpan);
/**
 * SOURCE AgreeButton @ squareup/bbfrontend/common/workflow/screens/onboarding.proto at 325:3
 */
ConfirmTosConfigs.AgreeButton = $root.lookupType('squareup.bbfrontend.service.v1.ConfirmTosConfigs.AgreeButton');
fixType(ConfirmTosConfigs.AgreeButton, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ConfirmTosConfigs.AgreeButton);